import * as React from 'react'
import { View } from 'react-native';

export default function LoadingSpinnerModal(_props: { visible: boolean }) {
  return (
    <View />
    // TODO implement
  )
}
